import { render, staticRenderFns } from "./AdminHomeMenu.vue?vue&type=template&id=aea9bdba&%3Akey=updatedKey"
import script from "./AdminHomeMenu.vue?vue&type=script&lang=js"
export * from "./AdminHomeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports